import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0cadc4bd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "th"
};
const _hoisted_3 = {
  style: {
    "padding": "0"
  }
};
const _hoisted_4 = ["value"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  style: {
    "position": "relative",
    "height": "50px",
    "display": "flex",
    "border-top": "1px solid #b60909"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lf",
  style: {
    "line-height": "50px"
  }
}, "期数", -1));
const _hoisted_8 = {
  key: 0,
  class: "ri",
  style: {
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_9 = {
  key: 1,
  class: "ri"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "|", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "合", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-size": "5px"
  }
}, "|", -1));
const _hoisted_13 = {
  key: 0,
  class: "jiazai"
};
const _hoisted_14 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_15 = {
  class: "tongji"
};
const _hoisted_16 = {
  class: "lf"
};
const _hoisted_17 = {
  class: "ri"
};
const _hoisted_18 = ["width", "height"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [_createElementVNode("li", _hoisted_3, [_createElementVNode("select", {
    style: {
      "width": "100%",
      "height": "100%",
      "text-align": "center"
    },
    onChange: _cache[0] || (_cache[0] = $event => $options.changeHm($event.target.value))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.hm, (v, i) => {
    return _openBlock(), _createElementBlock("option", {
      key: i,
      value: i
    }, _toDisplayString(v), 9, _hoisted_4);
  }), 128))], 32)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.th, (v, i) => {
    return _withDirectives((_openBlock(), _createElementBlock("li", {
      key: i,
      class: _normalizeClass($data.id == i ? 'active' : ''),
      onClick: $event => $options.changeTi(i)
    }, _toDisplayString(v), 11, _hoisted_5)), [[_vShow, i > 0]]);
  }), 128))]), _createElementVNode("div", _hoisted_6, [_hoisted_7, $data.id == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.numcals, (v, i) => {
    return _openBlock(), _createElementBlock("div", {
      key: i
    }, _toDisplayString(v), 1);
  }), 128))])) : _createCommentVNode("", true), $data.id !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cals[$data.id], (v, i) => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass($options.ballsize($data.id) + ' ballti'),
      style: _normalizeStyle($options.itemlf($data.id, i)),
      key: v
    }, [_createTextVNode(_toDisplayString(v), 1), _hoisted_10], 6)), [[_vShow, $data.id !== 6]]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.heshucals, (v, i) => {
    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass($options.ballsize($data.id) + ' ballti'),
      style: _normalizeStyle($options.itemlf($data.id, i)),
      key: v
    }, [_hoisted_11, _createTextVNode(_toDisplayString(v), 1), _hoisted_12], 6)), [[_vShow, $data.id == 6]]);
  }), 128))])) : _createCommentVNode("", true)]), $props.data.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 加载数据中…… ")) : _createCommentVNode("", true), _createVNode(_Transition, null, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tlist, (v, i) => {
      return _openBlock(), _createElementBlock("div", {
        class: "line",
        key: i
      }, [_createElementVNode("div", _hoisted_16, [_createTextVNode(_toDisplayString(v.year), 1), _createElementVNode("p", null, [_createElementVNode("b", null, _toDisplayString(v.qi), 1)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
        class: _normalizeClass($options.ballsize($data.id) + ' ball'),
        style: _normalizeStyle({
          'background': $options.bcolor($data.id, v.i),
          'left': v.lfvalue + '%',
          'top': v.topvalue
        })
      }, _toDisplayString(v.tm), 7)])]);
    }), 128))]), _createElementVNode("canvas", {
      id: "canvas",
      ref: "canvas",
      width: $data.cvswidth,
      height: $data.cvsheight,
      style: _normalizeStyle('position: absolute;transform: translate(-50%,0);z-index: 2;width:' + $data.cvswidth + 'px;max-width:540px;height:' + $data.cvsheight + 'px')
    }, null, 12, _hoisted_18)], 512), [[_vShow, $data.divshow]])]),
    _: 1
  })]);
}